module.exports = __webpack_public_path__ + "static/img/开幕式.458e5d6f.jpg";